<div class="flex flex-row items-center">
  @if (index) {
    <app-index-icon [index]="index"></app-index-icon>
  }

  @if (icon) {
    <svg-icon class="mr-1 w-4" preserveAspectRatio="none" [src]="icon"></svg-icon>
  }

  <span class="text flex" [class.font-bold]="isLabelBold" [class.with-colon]="labelWithColon">
    {{ label | translate: (labelParamsObj || {}) }}
  </span>

  @if (infoTooltip) {
    <svg-icon
      #tooltipOnPreview="ngbTooltip"
      class="help-icon relative"
      [class.tooltip-opened]="tooltipOnPreview.isOpen()"
      [class.disabled]="disabled"
      [src]="'info-grey'"
      [stretch]="true"
      [ngbTooltip]="infoTooltip"
      [tooltipClass]="infoTooltipClass + ' ' + 'default-tooltip'"
      [keepOnHover]="keepTooltipOnHover"
      [disableTooltip]="disabled"
      [placement]="infoTooltipPlacement"
    ></svg-icon>
  }

  @if (required) {
    <span
      class="asterisk"
      [ngbTooltip]="'core.formControls.requiredTooltip' | translate"
      [tooltipClass]="'required-mark-tooltip'"
    ></span>
  }

  @if (descriptionTooltipText) {
    <app-info-icon
      class="flex"
      [tooltipText]="descriptionTooltipText"
      [tooltipPosition]="'top'"
      [disableTooltip]="disabled"
    ></app-info-icon>
  }
</div>

@if (sublabel) {
  <span class="mt-1 mb-2 font-main text-base text-navy-70">{{ sublabel | translate }}</span>
}
